import Modal from "react-bootstrap/lib/Modal";
import Button from "react-bootstrap/lib/Button";
import React from "react";

export function DeleteModal(props) {
    return (
        <Modal show={props.show} onHide={props.handleClose}>
            <Modal.Body>
                <span>
                    <strong style={{fontSize: "16px"}}> Are you sure you want to delete this content?</strong>
                    {props.advise}
                </span>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.handleClose}>No</Button>
                <Button bsStyle="danger" onClick={props.handleDeleteClick}>DELETE</Button>
            </Modal.Footer>
        </Modal>
    )
}
